import usePortal from 'react-useportal';

function Background() {
    var { openPortal, closePortal, isOpen, Portal } = usePortal();

    return (
        <Portal>
            <div className="ARBackground"></div>
        </Portal>
    );
}

export default Background;
